/* tslint:disable */
require('./UrlRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_1ecf0f1b',
  relative: 'relative_1ecf0f1b',
  image: 'image_1ecf0f1b',
  link: 'link_1ecf0f1b',
  fabricIcon: 'fabricIcon_1ecf0f1b',
};

export default styles;
/* tslint:enable */